/**
 * پالت‌های سایت — پوسته‌ی «Golden Hour» (نگاه کن به web-demos/09-goldenhour.html).
 *
 * چرا سایت پالتِ خودش رو داره و از `coral`ِ اپ استفاده نمی‌کنه: حالتِ روشنِ
 * سایت عمداً گرم و کاغذی است (کرم/مرجانی)، در حالی که `coral`ِ اپ آبیِ پودریه.
 * این تصمیمِ طراحی بود، نه تصادف. ولی حالتِ **تیره**ی سایت همون شبانه‌ی اپه —
 * پس عمداً از `PALETTES.night` ساخته می‌شه تا هر تغییری در پالتِ شبانه خودکار
 * به سایت هم برسه.
 */
import { PALETTES } from './app.ts';
import type { WebPalette } from './palette.ts';

export type WebThemeName = 'light' | 'dark';

const light: WebPalette = {
  bg: '#FFF9F2', bg2: '#FBEFE2', surface: '#FFFFFF', surface2: '#FBEFE2',
  line: '#F1E2D2',
  ink: '#3A2A20', ink2: '#82675A', ink3: '#B49B8C',
  brand: '#E86A45', brandText: '#CE4F2C', brandInk: '#FFFFFF',
  brandSoft: '#FCE8E0', brandEdge: '#F6CDBC',
  gold: '#EFA43E', goldSoft: '#FCF0DA', rose: '#E88AA0',
  accent: '#2E8C74', accentSoft: '#E0F1EB', accent2: '#5AB795', notice: '#E08A3C',
  danger: '#C0392B', warn: '#B45309', warnSoft: '#FCF0DA',
  scrim: '#3A2A2066',
  shadow: '0 2px 6px #a0653a12, 0 12px 34px #a0653a14',
  shadowLift: '0 4px 10px #a0653a16, 0 20px 50px #a0653a1e',
  glow: '0 0 0 6px #EFA43E1A',
  isDark: false,
};

const dark: WebPalette = {
  ...PALETTES.night,
  bg2: '#141E33',
  // در حالتِ تیره لبه‌ی برند یک پله روشن‌تر از اپه؛ روی مانیتورِ بزرگ لبه‌ی
  // #3C3117 عملاً دیده نمی‌شه.
  brandEdge: '#4A3B14',
  gold: '#F0A83C', goldSoft: '#33280F', rose: '#C88AA8',
  shadow: '0 2px 6px #00000033, 0 12px 34px #00000033',
  shadowLift: '0 4px 10px #00000044, 0 20px 50px #00000055',
  glow: '0 0 0 6px #F0A83C1A',
};

export const WEB_PALETTES: Record<WebThemeName, WebPalette> = { light, dark };
